import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Row } from 'antd';
import AIProgressBar from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AIProgressBar/AIProgressBar';
import AiSuggestPrompts from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiSuggestPrompts/AiSuggestPrompts';
import { useMessageService } from 'components/Message/useMessageService';
import SpeechAntdTextArea, { SpeechAntdTextAreaHandle } from 'components/UiKit/SpeechAntdTextArea/SpeechAntdTextArea';
import { useEffect, useRef, useState } from 'react';

type AllProps = {
  tones: string[];
  onBack: () => void;
  onSave: (emotionFocus?: string, shouldExit?: boolean) => void;
};

function AiCreationFocus({ tones, onBack, onSave }: AllProps) {
  const focusRef = useRef<SpeechAntdTextAreaHandle>(null);
  const { message, updateMessageAiFields } = useMessageService();
  const [emotionFocus, setEmotionFocus] = useState<string>('');

  const handleSubmit = async (shouldExit = false) => {
    const finalFocus = (await focusRef.current?.flush()) ?? emotionFocus;
    setEmotionFocus(finalFocus);

    await updateMessageAiFields({ aiFocus: finalFocus });
    onSave(finalFocus, shouldExit);
  };

  useEffect(() => {
    setEmotionFocus(message?.aiFocus || '');
  }, [message?.aiFocus]);

  if (!message) return null;

  return (
    <div className="ai-creation-focus create-message-component-full-height">
      <div>
        <AIProgressBar currentStep={2} />
        <div className="create-message-component-title">What's the core message you want to convey?</div>
        <div className="create-message-component-subtitle">
          Share the main feeling, thought, or message you want to convey to your loved ones.
        </div>

        <AiSuggestPrompts
          type={message.type}
          tones={tones}
          recipientName={message.contacts?.[0]?.name}
          recipientRelationship={message?.contacts?.[0]?.relationship}
          eventType={message.eventType}
          slot="What's the core message you want to convey?"
        />

        <SpeechAntdTextArea
          ref={focusRef}
          autoFocus
          value={emotionFocus}
          onChange={(value) => {
            setEmotionFocus(value);
          }}
          placeholder="For example: 'I want them to know how proud I am of their accomplishments' or 'I want to express my love and gratitude for all the memories we shared'..."
        />
      </div>

      <Row className="create-message-component-footer">
        <Col span={12}>
          <Button onClick={onBack} type="link">
            <ArrowLeftOutlined /> Back
          </Button>
        </Col>
        <Col span={12} className="text-right">
          <Flex gap={20} justify="flex-end">
            <Button onClick={() => handleSubmit(true)}>Save & Exit</Button>
            <Button type="primary" onClick={() => handleSubmit()}>
              Next
            </Button>
          </Flex>
        </Col>
      </Row>
    </div>
  );
}

export default AiCreationFocus;
